import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const useGROUPED_NON_COMPLIANCES_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'GROUPED_NON_COMPLIANCES_CONFIG',
    name: t('widgets.groupedNonCompliances.name'),
    description: t('widgets.groupedNonCompliances.description'),
    color: 'red',
    icon: 'RiDashboard3Line',
    categories: [t('widgets.groupedNonCompliances.category')],
    noPreview: true,

    initialState: {
      size: { width: 100, height: 800 },
      data: {}
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
